<template>
    <Head title="Desempenho" />
    <AuthenticatedLayout>
        <Heading title="Desempenho" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div
            class="component-background-mobile px-4 pb-4 min-h-screen"
        >
            <section class="xl:px-[15.5vw] pt-8 sm:pt-2 flex">
                <div class="max-w-[751px] w-full h-full">
                    <div v-if="highPermission.includes(jobTitle)">
                        <div>
                            <h1 class="text-primary font-bold">
                                Desempenho Equipe
                            </h1>
                            <p>
                                Para acompanhar o desempenho da sua equipe,
                                selecione no filtro a campanha, o período,
                                lojas, região e execução que quer visualizar.
                            </p>
                        </div>
                        <div class="flex items-center gap-x-4">
                            <FilterTeamPerformance
                                :participants="participants"
                                :subregions="subregions"
                                :campaigns="campaigns"
                                :seasonWeeks="weeks"
                                :regions="regions"
                                @updateFilter="filterTeamPerformance($event)"
                            />
                            <a
                                v-if="isFiltered"
                                class="text-blue-600 hover:underline cursor-pointer text-sm"
                                @click="clearFilter()"
                                >Limpar Filtro</a
                            >
                        </div>

                        <div
                            class="max-w-[461px] p-8 flex justify-center items-center rounded-2xl bg-gray-100"
                        >
                            <div
                                class="h-full w-full flex justify-center items-center rounded-2xl sm:flex-col gap-4"
                            >
                                <div class="flex-grow relative xl:max-w-[35%]">
                                    <div
                                        class="outer w-[120px] h-[120px] rounded-[50%] p-5 bg-[#79FF9D]"
                                    >
                                        <div
                                            class="inner h-[80px] w-[80px] rounded-[50%] flex justify-center items-center bg-white"
                                        >
                                            <div
                                                id="number"
                                                class="font-semibold text-primary text-[20px]"
                                            >
                                                {{ progressValue }}%
                                            </div>
                                        </div>
                                    </div>
                                    <svg
                                        class="absolute top-0 left-0"
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        width="160px"
                                        height="160px"
                                    >
                                        <defs>
                                            <linearGradient id="GradientColor">
                                                <stop
                                                    offset="0%"
                                                    stop-color="#e91e63"
                                                />
                                                <stop
                                                    offset="100%"
                                                    stop-color="#673ab7"
                                                />
                                            </linearGradient>
                                        </defs>
                                        <circle
                                            class="progress-bar fill-[none] stroke-[#0771c5] stroke-[20px]"
                                            cx="60px"
                                            cy="60px"
                                            r="50"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </div>
                                <div
                                    class="pl-[16px] xl:max-w-[40%] text-primary"
                                >
                                    <h1 class="font-bold">Meta de equipe</h1>
                                    <p class="text-sm mt-2">
                                        <strong>META</strong>:
                                        {{ teamPerformance?.total }}
                                    </p>
                                    <p class="text-sm">
                                        <strong>REALIZADO</strong>:
                                        {{ teamPerformance?.achieved }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <p
                            class="text-[10px] text-left flex items-center mt-3.5"
                        >
                            Última atualização:
                            {{
                                lastUpdate
                                    ? formatUpdatedDate(lastUpdate)
                                    : getCurrentDate()
                            }}
                        </p>
                        <div class="mt-14">
                            <h1 class="text-primary font-bold">
                                Distribuição de Resultado por Participante
                            </h1>
                            <p>Para exibir a equipe, aplique os filtros!</p>

                            <div
                                v-if="teamPerformanceByParticipant?.length > 0"
                                class="bg-white rounded-2xl border-primary border p-4 mt-4"
                            >
                                <PhotosByParticipantTable
                                    :data="computedTeamPerformanceByParticipant"
                                />
                            </div>

                            <div
                                v-if="teamPerformanceByParticipant?.length <= 0"
                                class="mt-4"
                            >
                                <strong>Total:</strong> 100%
                            </div>
                        </div>
                    </div>
                    <IndividualPerformance
                        v-if="lowPermission.includes(jobTitle)"
                        :galleries="galleries"
                        :campaigns="campaigns"
                        :regions="regions"
                        :subregions="subregions"
                        :jobTitle="jobTitle"
                        :participantPerformance="participantPerformance"
                        :participantPerformanceWithWeight="participantPerformanceWithWeight"
                        :teamPerformance="teamPerformance"
                    />
                </div>
            </section>
        </div>
    </AuthenticatedLayout>
</template>
<script>
import { Head } from "@inertiajs/inertia-vue3";
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Input from "@/Components/UI/Form/Select.vue";
import FilterTeamPerformance from "@/Components/FilterTeamPerformance.vue";
import FilterIndividualPerformance from "@/Components/FilterIndividualPerformance.vue";
import IndividualPerformance from "@/Components/Performance/Individual/index.vue";
import Gallery from "@/Components/Gallery.vue";
import PhotosByParticipantTable from "@/Components/Performance/Team/PhotosByParticipantTable.vue";
import moment from "moment";

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Icon,
        Input,
        FilterTeamPerformance,
        FilterIndividualPerformance,
        Gallery,
        PhotosByParticipantTable,
        IndividualPerformance,
    },
    props: {
        galleries: Object,
        campaigns: Object,
        regions: Object,
        subregions: Object,
        jobTitle: Object,
        participants: Object,
        teamPerformance: {
            total: Number,
            achieved: Number,
        },
        teamPerformanceByParticipant: Array,
        participantPerformance: Array,
        participantPerformanceWithWeight: Object
    },
    data() {
        return {
            showFilterPeriod: false,
            showSelectStatus: false,
            marketStatus: "",
            propertyFilter: "",
            currentGallery: "",
            currentReason: "",
            weeks: [],
            regionsOptions: "",
            highPermission: ["GERENTE", "LIDER", "LÍDER", "COORDENADOR"],
            lowPermission: ["PROMOTOR", "REPOSITOR"],
        };
    },
    computed: {
        progressValue() {
            return this.getPercent(this.teamPerformance?.achieved);
        },
        progressCssValue() {
            return 320 - this.progressValue * 3.2;
        },
        computedTeamPerformanceByParticipant: function () {
            return this.teamPerformanceByParticipant.map((item) => ({
                ...item,
                progress: this.getProgressPercent(item.galleries),
            }));
        },
    },
    mounted() {
        this.fetchWeeks();
    },
    methods: {
        getCurrentDate : function () {
            return new moment().format('DD/MM/YYYY [às] HH:mm');
        },
        fetchWeeks() {
            const actualWeek = moment().startOf("isoWeek").format("W");
            const MomentWeek = moment()
                .week(actualWeek)
                .startOf("isoWeek")
                .format("W");
            const hotfix = actualWeek != MomentWeek ? 1 : 0;

            let weeksInYear = moment().isoWeeks();

            for (
                let weekNumber = 1;
                weekNumber < weeksInYear + 1;
                weekNumber++
            ) {
                const startDay = moment()
                    .week(weekNumber + hotfix)
                    .startOf("week");
                const endDay = moment()
                    .week(weekNumber + hotfix)
                    .endOf("week");

                const week = {
                    name: `Semana ${weekNumber}`,
                    start: startDay.locale("pt-br").format("DD/MM/YYYY"),
                    startFormatted: startDay
                        .locale("pt-br")
                        .format("YYYY-MM-DD"),
                    end: endDay.locale("pt-br").format("DD/MM/YYYY"),
                    endFormatted: endDay.locale("pt-br").format("YYYY-MM-DD"),
                };

                this.weeks.push(week);
            }
        },
        setPropertyName() {
            this.propertyFilter == "nameHigher"
                ? (this.propertyFilter = "nameLower")
                : (this.propertyFilter = "nameHigher");
        },
        setPropertyResult() {
            this.propertyFilter == "resultHigher"
                ? (this.propertyFilter = "resultLower")
                : (this.propertyFilter = "resultHigher");
        },
        setPropertyTotal() {
            this.propertyFilter == "totalHigher"
                ? (this.propertyFilter = "totalLower")
                : (this.propertyFilter = "totalHigher");
        },
        getPercent(progress) {
            if (!this.teamPerformance?.total) return 0;
            const total = this.teamPerformance?.total || 100;
            const partial = progress || 0;
            return Math.round((100 * partial) / total);
        },
        getProgressPercent(progress) {
            if (!this.teamPerformance?.achieved) return 0;
            const total = this.teamPerformance?.achieved || 100;
            const partial = progress || 0;
            return Math.round((100 * partial) / total);
        },
        filterTeamPerformance(data) {
            this.$inertia.post("/performance/team/filter", data);
        },
    },
};
</script>
<style scoped>
.grid-cols-ranking-participants:nth-child(2n + 2) {
    background-color: #dbdbdb;
}
.progress-bar {
    stroke-dasharray: 320;
    stroke-dashoffset: v-bind(progressCssValue);
    animation: anim 2s linear forwards;
}
</style>
